import React from 'react'
import { Container } from 'grid'

export default ({ children, className }) => <div is='main'>{children}</div>
